import api from "./axios";
import type { ApiResponseEnvelope } from "@/struct/ApiEnvelope";
import type { PremiumCategoryStruct } from "@/struct/PremiumStruct";
import type { PremiumNumberType } from "@/struct/PremiumPhoneStruct";

export default class PremiumService {
  changePremiumNumber = (number: number, type: string) => {
    return api.post("/api/ems/msisdn-swap", {
      msisdn: number,
      type: type,
    });
  };

  getPremiumCategory = () => {
    return api.get<ApiResponseEnvelope<PremiumCategoryStruct[]>>(
      "/api/ems/get-msisdn-types"
    );
  };

  getPremiumNumbers = (data: {
    search: string;
    limit: number;
    type: string;
    facilityId: number;
    start?: number;
  }) => {
    return api.get<ApiResponseEnvelope<PremiumNumberType[]>>(
      "/api/ems/get-msisdn-list",
      {
        params: {
          ...data,
        },
      }
    );
  };
}
